// extracted by mini-css-extract-plugin
module.exports = {"cardcontainer":"PopularPlaces_cardcontainer__NRG1b","popularplacescontainer":"PopularPlaces_popularplacescontainer__29OOv"};